import React, { useCallback, useState } from 'react';
import EyeOffIcon from 'views/components/icons/EyeOff';
import EyeOnIcon from 'views/components/icons/EyeOn';
import TrashIcon from 'views/components/icons/Trash';
import UploadIcon from 'views/components/icons/Upload';
import ColorPicker from '../Connections/ColorPicker';
import { debounce } from 'lodash';
import Config from 'Config';
import CloseIcon from 'views/components/icons/Close';
import { toast } from 'utils/Toast';
import imageCompression from 'browser-image-compression';

const compressImgLabel = async (file) => {
  const options = {
    maxSizeMB: 0.5,
    maxWidthOrHeight: 200,
  };
  try {
    return await imageCompression(file, options);
  } catch (error) {
    console.error('Error compressing image:', error);
    return file;
  }
};

const LabelColumn = ({ label, formId, deleteLabel, updateLabel, updateLabelImage, isPickerOpen, handleCurrentPicker }) => {
  const [inputValue, setInputValue] = useState(label.value);
  const COLORS = ['#F9C49E', '#FFE9BD', '#D5EDC3', '#ADE1E4', '#B3D1F3', '#D4CBE2', '#FFFFFF'];
  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      // Only jpeg, png, webp, and bmp images
      if (!['image/jpeg', 'image/png', 'image/webp', 'image/bmp'].includes(selectedFile.type)) {
        toast('Please select a valid image file (jpeg, png, webp, bmp).', 'error');
        return;
      }
      // limit file size to 5MB
      if (selectedFile.size > 5 * 1024 * 1024) {
        toast('Image size must be under 5MB.', 'error');
        return;
      }
      const compressedFile = await compressImgLabel(selectedFile);
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1];
        const extension = reader.result.substring(reader.result.indexOf('/') + 1, reader.result.indexOf(';'));
        updateLabelImage({ id: label.id, img: base64String, extension: `.${extension}` });
      };
      reader.readAsDataURL(compressedFile);
    }
  };

  const onUpdateDebounced = useCallback(
    debounce(
      (newValue) => updateLabel({ customLabelId: label.id, value: newValue, color: label.color, labelOffset: label.offset, visible: label.visible }),
      Config.TEXT_INPUT_DELAY
    ),
    [formId]
  );

  const onInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    onUpdateDebounced(value);
  };

  const _deleteLabel = () => {
    deleteLabel(label.id);
  };

  const toggleVisibility = () => {
    updateLabel({ customLabelId: label.id, value: label.value, color: label.color, labelOffset: label.offset, visible: !label.visible });
  };

  const onChangeColor = (newValue) => {
    updateLabel({ customLabelId: label.id, value: label.value, labelOffset: label.offset, visible: label.visible, color: newValue });
  };

  const onColorClick = (color) => {
    handleCurrentPicker(null);
    onChangeColor(color);
  };

  const togglePicker = (id) => {
    handleCurrentPicker(id);
  };

  const removeFile = () => {
    updateLabelImage({ id: label.id, img: null, extension: null });
  };

  return (
    <div className="column">
      <div className="label icon-container clickable icon">
        {label.imgUrl ? (
          <div className="image-selected" title="Remove image" onClick={removeFile}>
            <img src={label.imgUrl} alt="Label Icon" />
            <CloseIcon width={16} height={17} color="white" />
          </div>
        ) : (
          <div title="Add an image">
            <UploadIcon width={16} height={17} color="#333333" />
            <input type="file" onChange={handleFileChange} accept="image/*" />
          </div>
        )}
      </div>
      <span className="label-input">
        <input value={inputValue} onChange={onInputChange} placeholder={'Add a label (optional)'} />
      </span>

      <ColorPicker
        value={label.color}
        onColorClick={onColorClick}
        onChange={onChangeColor}
        open={isPickerOpen}
        togglePicker={togglePicker}
        formId={formId}
        whiteAvailable={true}
        colors={COLORS}
      />
      <div className={'clickable icon'} onClick={toggleVisibility}>
        {label.visible ? <EyeOnIcon width={16} height={16} color="black" /> : <EyeOffIcon width={16} height={16} color="black" />}
      </div>
      {/* {deleteMetroLabelLoading ? (
              <span className="delete loading" />
            ) : ( */}
      <div className={'clickable icon'} onClick={_deleteLabel}>
        <TrashIcon width={13} height={14} color="#333333" />
      </div>
    </div>
  );
};

export default LabelColumn;
